export default __webpack_public_path__ + "static/insta-hotels-9-b0f09b8ba060ce8a9e86a05a81c5c05c.jpg";